<template :key="selected.aws_resource_name">
  <v-app id="inspire" class="tw-bg-cover">
    <v-main>
      <div class="tw-w-full tw-flex">
        <v-col class="image tw-hidden lg:tw-block image tw-h-auto tw-flex tw-justify-center" cols="12" sm="12" md="7">
          <div class="tw-w-full tw-h-screen tw-flex tw-justify-center tw-items-end">
            <div class="tw-w-10/12 tw-flex flex-wrap tw-justify-center tw-mt-10 lg:tw-mt-0 tw-px-4 md:tw-px-12">
              <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-text-left">
                <!-- <img class="tw-w-20" src="/images/ellipses.jpg"  alt="smiley"> -->
                <div class="tw-px-2 md:tw-px-5">
                  <h1 class="c-white-text tw-text-xl md:tw-text-xl lg:tw-text-2xl tw-font-medium">Convenience at the click of a button.</h1>
                  <p class="tw-font-bold c-white-text">Buy, Renew and Claim For Comfort & Peace in Life.</p>
                </div>
              </div>
              <div v-if="show" class="tw-px-16 tw-w-full tw-mt-4 tw-text-left tw-text-white tw-flex tw-items-center">
                <a id="playstore-link" class="" href="https://play.google.com/store/apps/details?id=ke.co.apollo.client.app" target="_blank" rel="noopener"><img src="/images/google-play-badge.png" width="130" alt="play store"></a>
                <p class="tw-text-xs md:tw-text-base md:tw-text-left tw-px-2  tw-mt-3">You can also download our Motor Happiness App on the Google play store</p>
              </div>
            </div>
          </div>
        </v-col>
        <v-col class="tw-px-6 md:tw-px-24 tw-flex tw-flex-wrap tw-items-center tw-justify-center" id="signup" cols="12" sm="12" md="5" >
          <v-card class="tw-w-full elevation-5 tw-mt-12">
            <div class="tw-w-full tw-flex tw-justify-center">
              <img src="/logo.jpg" class="tw-w-24 md:tw-w-32 tw-mt-4 md:tw-mt-6" alt="logo">
            </div>
            <v-card-text class="tw-px-4 md:tw-px-10" >
              <v-form v-model="isValid">
                <v-radio-group
                  v-model="selected"
                  id="user-pool-selector"
                  @change="reconfigure"
                  row
                  >
                  <v-radio v-for="config in configurations" :key="config.aws_resource_name" :value="config" :label="config.aws_resource_name"></v-radio>
                </v-radio-group>
                <!-- <select
                v-model="selected"
                id="user-pool-selector"
                @change="reconfigure">
                  <option v-for="config in configurations" :key="config.aws_resource_name" :value="config">
                    {{ config.aws_resource_name }}
                    </option>
                </select> -->
                <v-text-field
                    id="id_number"
                    class="my-3"
                    label="National ID"
                    type="text"
                    v-model="form.id_number"
                    v-on:change="fetchName"
                    :rules="[required('National ID')]"
                >
                  <v-icon slot="prepend" color="primary">mdi-folder</v-icon>
                </v-text-field>

                <v-text-field
                    id="mobile"
                    class="my-3"
                    label="Mobile No."
                    type="text"
                    v-model="form.mobile"
                    :rules="[required('Mobile No.'), mobileFormat()]"
                >
                  <v-icon slot="prepend" color="primary">mdi-phone</v-icon>
                </v-text-field>

                <v-text-field
                    id="email"
                    class="my-3"
                    label="Email Address"
                    type="email"
                    v-model="form.email"
                    :rules="[required('Email'), emailFormat()]"
                >
                  <v-icon slot="prepend" color="primary">mdi-email</v-icon>
                </v-text-field>

                <v-text-field
                    id="kra"
                    class="my-3"
                    label="KRA PIN"
                    type="text"
                    v-model="form.kra"
                    :rules="[required('KRA PIN'), kraPinFormat()]"
                >
                  <v-icon slot="prepend" color="primary">mdi-folder</v-icon>
                </v-text-field>

                <v-text-field
                    class="my-3"
                    id="password"
                    label="Password"
                    :type="passwordField"
                    v-model="form.password"
                    :rules="[required('Password'), minLength('password', 8), lowerCaseFormat(), upperCaseFormat(), digitFormat(), specialCharFormat()]"
                >
                  <v-icon slot="prepend" color="primary">mdi-lock</v-icon>
                  <v-icon slot="append" color="primary" class="tw-cursor-pointer" @click="passwordField = passwordField === 'password' ? 'text' : 'password'">{{ passwordField === 'password' ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                </v-text-field>

                <v-text-field
                    class="tw-mb-5 my-3"
                    id="ConfirmPassword"
                    label="Confirm Password"
                    :type="passwordConfirmField"
                    v-model="form.confirmPassword"
                    :rules="[required('Confirm Password'), confirmPassword('Confirm Password', form.password)]"
                >
                  <v-icon slot="prepend" color="primary">mdi-lock</v-icon>
                  <v-icon slot="append" color="primary" class="tw-cursor-pointer" @click="passwordConfirmField = passwordConfirmField === 'password' ? 'text' : 'password'">{{ passwordConfirmField === 'password' ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                </v-text-field>

                <v-checkbox
                    id="checkbox"
                    v-model="form.terms"
                    :rules="[check()]"
                >
                  <div slot="label">Accept Terms and Conditions</div>
                </v-checkbox>

                <terms-and-conditions  class="tw-mb-5" />

              </v-form>
            </v-card-text>
            <v-card-actions class="col-sm-6 offset-sm-3">
              <v-btn block large
                     id="signUp"
                     color="primary"
                     @click="onSignUp"
                     :disabled="!isValid"
                     :loading="loading">
                Sign Up
              </v-btn>
            </v-card-actions>
            <v-card-actions class="tw-w-full tw-flex justify-center tw-mb-5">
              <span class="c-gray-text body-2" >Already Have an account ? <router-link class="tw-font-bold" :to="{ name: 'SignIn', query: query }">Sign In</router-link> </span>
            </v-card-actions>
          </v-card>

          <div class="tw-w-full">
            <div class="tw-w-full tw-flex tw-my-4 lg:tw-my-6 tw-items-center c-gray-text tw-text-center">
              <div class="tw-w-5/12">
                <hr>
              </div>
              <div class="tw-w-2/12">
                OR
              </div>
              <div class="tw-w-5/12">
                <hr>
              </div>
            </div>
            <get-quote :query="query" />
          </div>
        </v-col>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import TermsAndConditions from '@/components/TermsAndConditions';
import GetQuote from '@/components/auth/GetQuote';
import validations from '@/utils/validations';
import helpers from '@/utils/helpers';
import axios from 'axios';

import Amplify from '@aws-amplify/core';
import { mapGetters } from 'vuex';
import { FB_SIGNUP, USER_EMAIL } from '@/utils/const';
import AWSResources from '@/utils/aws-exports';

const { Logger } = Amplify;
const logger = new Logger('SignUpPage');

export default {
  metaInfo: {
    title: 'Sign Up',
  },
  components: { GetQuote, TermsAndConditions },
  data() {
    return {
      form: {
        fullname: this.fullname,
        mobile: '+254',
        email: '',
        id_number: '',
        kra: '',
        password: '',
        confirmPassword: '',
        terms: '',
      },
      ...validations,
      loading: false,
      isValid: false,
      query: '',
      passwordField: 'password',
      passwordConfirmField: 'password',
      show: false,
      selected: AWSResources[0],
      configurations: AWSResources,
    };
  },
  created() {
    Amplify.configure(this.selected);
  },
  computed: {
    ...mapGetters('auth', ['hasAuthenticationStatus', 'isConfirmed', 'authenticationStatus']),
  },
  mounted() {
    const quote = this.$route.query.q;
    const benefit = this.$route.query.b;
    if (!!quote && !!benefit) {
      this.query = this.$route.query;
    }
    this.$store.dispatch('auth/clearAuthenticationStatus');
  },
  methods: {
    fetchName() {
      axios.get(`/customer/gis/policies/iprsdetail?idNumber=${this.form.id_number}`)
        .then((response) => {
          const fName = response.data.object[0].firstName;
          const mName = response.data.object[0].otherName;
          const lName = response.data.object[0].surname;
          const fullnameIPRS = fName + ' ' + mName + ' ' + lName; // eslint-disable-line prefer-template
          this.fullname = fullnameIPRS;
        });
    },
    reconfigure() {
      Amplify.configure(this.selected);
    },
    async onSignUp() {
      this.loading = true;
      logger.debug('sign-up');
      this.$cookies.set(USER_EMAIL, this.form.email);
      await this.$store.dispatch('auth/signUp', {
        username: this.form.email,
        password: this.form.password,
        attributes: {
          name: this.fullname,
          email: this.form.email,
          phone_number: this.form.mobile,
          'custom:id_number': this.form.id_number,
          'custom:kra-pin': this.form.kra,
          preferred_username: this.form.kra,
        },
      }).then(() => {
        this.loading = false;
        if (this.hasAuthenticationStatus) {
          if (this.authenticationStatus.variant === 'error') {
            this.$toast.error(this.authenticationStatus.message, 'Error');
          } else {
            this.$analytics.logEvent(FB_SIGNUP, {
              name: this.form.fullname,
              email: this.form.email,
            });
            this.$toast.success(this.authenticationStatus.message, 'Success');
          }
        }
      });

      if (this.hasAuthenticationStatus && this.authenticationStatus.variant === 'success') {
        helpers.clearForm(this.form);
        this.$router.push({ name: 'ConfirmOtp', query: this.query });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .image {
    background-image: url('/images/bg-1.jpg');
    background-repeat: no-repeat;
    background-attachment: cover;
    background-position: center;
    @media only screen and (min-width: 1280px) {
      background-size: cover;
    }
  }

</style>
